// The SOCIALS check on `/debug`: per Content pill, what landed and why Best Times does or does not fill.
//
// It reads the RESULT where the refresh trace reads the CALLS. Meta's per-post view reads ride a Graph batch
// that answers 200 with failed sub-requests inside, so a green trace can sit over a Facebook panel with nothing
// to rank — this is the read that tells those apart (built to verify a real Meta app on dev, 2026-10-03).
//
// Raw fetch, matching its `useConnectDebug` sibling: a band-scoped `[InternalController]` diagnostic reached only
// from `/debug`, where no org-lens middleware is mounted. Types come from the generated schema.
import type { components } from "@cntrl/api-client";
import { useApp } from "../appContext.js";
import { useBandQuery } from "./useBandQuery.js";
import { ApiError } from "./apiError.js";
import { API_URL } from "../../config/env.js";

export type SocialsCheckRow = components["schemas"]["SocialsCheckRow"];
export type SocialsCheckDoc = components["schemas"]["SocialsCheckDoc"];

const SOCIALS_KEY = ["debug", "socials"] as const;

/** No vendor call and no writes — the same reads and rules as the Content page, so it cannot disagree with it. */
export function useSocialsDebug() {
  const { tokenProvider } = useApp();
  return useBandQuery<SocialsCheckDoc>(SOCIALS_KEY, async (band) => {
    const bearer = tokenProvider.getBearer();
    const response = await fetch(`${API_URL}/api/v1/bands/${band}/debug/socials`, {
      method: "GET",
      credentials: "include",
      headers: bearer ? { Authorization: `Bearer ${bearer}` } : {},
    });
    if (!response.ok) {
      let problem: unknown;
      try {
        problem = await response.json();
      } catch {
        problem = undefined;
      }
      throw new ApiError(response.status, problem);
    }
    const body = (await response.json()) as { data?: SocialsCheckDoc };
    if (!body?.data) throw new ApiError(response.status, undefined);
    return body.data;
  });
}
